import React from "react";
import {useHelp} from "../../contexts/HelpContext";
import {getHelpTopic} from "../../content/helpContent";

interface HelpIconProps {
  topicId: string;
  className?: string;
  size?: "sm" | "md" | "lg";
  placement?: "inline" | "standalone";
}

const HelpIcon: React.FC<HelpIconProps> = ({topicId, className = "", size = "sm", placement = "inline"}) => {
  const {openHelp} = useHelp();
  const topic = getHelpTopic(topicId);

  if (!topic) {
    //console.warn(`Help topic not found: ${topicId}`);
    return null;
  }

  const handleClick = (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    openHelp(topicId);
  };

  const sizeClass = `help-icon-${size}`;
  const placementClass = `help-icon-${placement}`;

  return (
    <button
      className={`help-icon ${sizeClass} ${placementClass} ${className}`}
      onClick={handleClick}
      aria-label={`Help for ${topic.title}`}
      title={`Click for help on ${topic.title}`}
      type="button"
    >
      <i className="fa fa-info-circle" />
    </button>
  );
};

export default HelpIcon;
